import { T, useTranslate } from '@tolgee/react';
import { BaseSysMsgProps } from './types';
import { SystemMessage } from 'components/Dialogue';
import { memo } from 'react';
import { StarRate } from 'views/Review/components/Profile';
import { Tag } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as ThreeSvg } from 'views/Dashboard/PlatformData/assets/haoping.svg';
import { ReactComponent as TwoSvg } from 'views/Dashboard/PlatformData/assets/yiban.svg';
import { ReactComponent as OneSvg } from 'views/Dashboard/PlatformData/assets/chaping.svg';
import dayjs from 'dayjs';
import TransComponent from 'components/TransComponent';

export const SysCsatMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { channel, sendTime, sysCsatContent: { satisfactionScore } = {} } = raw;

  const { t } = useTranslate();

  if (!satisfactionScore && satisfactionScore !== 0) {
    return <></>;
  }

  return (
    <SystemMessage>
      <span className="mr-2">{dayjs(Number(sendTime)).format('MM-DD HH:mm:ss')}</span>
      <T
        keyName="买家给予x"
        params={{
          x: (
            <TransComponent
              content={
                <span className="ml-2">
                  {channel !== 'SHOPEE' ? (
                    <StarRate disabled value={satisfactionScore} />
                  ) : satisfactionScore === 2 ? (
                    <Tag color="green">
                      <Icon component={ThreeSvg} />
                      {t('domain.review.rating.positive')}
                    </Tag>
                  ) : satisfactionScore === 1 ? (
                    <Tag color="warning">
                      <Icon component={TwoSvg} />
                      {t('scene.chatWorkspace.messageThread.evaluation.rating.average')}
                    </Tag>
                  ) : satisfactionScore === 0 ? (
                    <Tag color="error">
                      <Icon component={OneSvg} />
                      {t('domain.review.status.negative')}
                    </Tag>
                  ) : (
                    <>-</>
                  )}
                </span>
              }
            />
          ),
        }}
      />
    </SystemMessage>
  );
});
